"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainType = exports.ModelEventType = void 0;
var ModelEventType;
(function (ModelEventType) {
    ModelEventType["DELETED"] = "deleted";
    ModelEventType["UPDATED"] = "updated";
    ModelEventType["CREATED"] = "created";
})(ModelEventType = exports.ModelEventType || (exports.ModelEventType = {}));
var DomainType;
(function (DomainType) {
    DomainType["ELECTRICITY"] = "electricite";
    DomainType["PLUMBING"] = "plomberie";
    DomainType["GAS"] = "gaz";
    DomainType["LOCKSMITHING"] = "serrurerie";
})(DomainType = exports.DomainType || (exports.DomainType = {}));
//# sourceMappingURL=model.js.map